import Label from "./Label";

type Props = { label: string | null | undefined; className?: string; required?: boolean };

export default function FieldTitle({ label, className = "", required }: Props) {
	if (!label) return null;
	return <Label text={label} required={required} titleCassName={"mt-2 mb-1 " + className} />;
}
